import * as React from "react";
import { FormatTemplateSearch } from "@/formatTemplate/components/FormatTemplateSearch";
import useFormatTemplates from "@/utils/formatTemplate/useFormatTemplates";
import useFormatTemplatesRecentlyUsed from "@/utils/formatTemplate/useRecentFormatTemplates";
import { usePresentationStore } from "@/state/presentationStore";

/** Format template picker for presentation chatbot formatting step (console FormattingSelection parity). */
export default function PresentationFormattingSelectionStep() {
  const currentStep = usePresentationStore((s) => s.currentStep);
  const step3Selection = usePresentationStore((s) => s.step3Selection);
  const setStep3Selection = usePresentationStore((s) => s.setStep3Selection);
  const setAnswersByStep = usePresentationStore((s) => s.setAnswersByStep);

  const { formatTemplates } = useFormatTemplates(10);
  const { formatTemplatesRecentlyUsed } = useFormatTemplatesRecentlyUsed(10);
  const limitedRecentlyUsedTemplates = formatTemplatesRecentlyUsed?.slice(0, 10) ?? [];

  React.useEffect(() => {
    if (step3Selection != null) return;
    const primaryRecent = limitedRecentlyUsedTemplates.find((t: { isPrimary?: boolean }) => t.isPrimary);
    if (primaryRecent) {
      setStep3Selection(primaryRecent.id);
      setAnswersByStep(currentStep, 1);
      return;
    }
    const primaryAvailable = formatTemplates?.find((t: { isPrimary?: boolean }) => t.isPrimary);
    if (primaryAvailable) {
      setStep3Selection(primaryAvailable.id);
      setAnswersByStep(currentStep, 1);
    }
  }, [
    formatTemplates,
    limitedRecentlyUsedTemplates,
    step3Selection,
    setStep3Selection,
    setAnswersByStep,
    currentStep,
  ]);

  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden text-sm text-gray-800">
      <div className="min-h-0 flex-1 overflow-y-auto">
        <FormatTemplateSearch
          isSelectionTemplate
          selectionMode
          hideStarButtons
          hidePrimaryLegend
          showSelectionLegend
          hideSelectionIntroText
          selectedTemplateId={step3Selection}
          onTemplateSelect={(template) => {
            const id = template?.id ?? null;
            setStep3Selection(id);
            setAnswersByStep(currentStep, id ? 1 : 0);
          }}
          hideRing
          selectionBorderColor="#FF5C35"
        />
      </div>
    </div>
  );
}
